module.exports = __webpack_public_path__ + "static/media/check-4.22a3cc7b.svg";